import React, { Component } from 'react';
import moment from 'moment-timezone';
import Revenue from "./Revenue";

// const tabs = ['Sales Tax Revenue', 'Sales Tax Liability'];

class SalesTax extends Component {
    state = {
      franchiseList: [],
      selected_date: moment(),
      franchise_name: '',
      summary: {},
      currentTab: 0
    };

    // tab change
    tabChange = (e) => {
      this.setState({
        currentTab: e,
      });
    };


  renderTab = () => {
    const {currentTab} = this.state;

    switch (currentTab) {
    case 0:
      return <Revenue {...this.props} />
    case 1:
      break;
    default:
      return <Revenue {...this.props} />
    }
  }

  render() {
    // let { franchiseList, franchise_name, currentTab } = this.state;
    return (
      <div className="account_expired_card">
        <ul className="breadcrumb">
          <li onClick={() => { this.props.ChangeComponent(0) }}>
            <span className="pointer"><i className="las la-angle-left"></i> Back to All Accounts</span>
          </li>
        </ul>
        <div className="block-row">
          <div className="filter_wrapper p-0">
            <div>
              <div className="left_side">
                <h2 className="m-0">Sales Tax Revenue Summary</h2>
              </div>
              <div className="right_side">
                {this.renderTab()}
              </div>
            </div>
          </div>
        </div>
                
      </div>
    );
  }
}

export default SalesTax;